<template>
  <div
    role="button"
    class="bg-background-neutral-secondary flex min-w-0 flex-1 items-center gap-1 rounded-2xl py-3 pl-4 pr-3"
    @click="
      emit('onDateSelect', searchFormCalendar.config.CALENDAR_MODES.SINGLE)
    "
  >
    <div class="flex min-w-0 flex-1 flex-col justify-center">
      <p class="text-text-neutral-quaternary text-xs leading-[18px]">
        {{ $t('main.dates.label') }}
      </p>
      <p
        class="text-text-neutral-primary truncate text-base font-semibold leading-[22px]"
      >
        {{ datesLabel }}
      </p>
    </div>
    <CalendarIcon class="text-text-positive-primary h-5 w-5 shrink-0" />
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import dayjs from 'dayjs';
  import { dateUtils, searchFormCalendar } from 'shared';

  import CalendarIcon from '@/assets/images/calendar-icon.svg?component';

  const props = defineProps<{
    dates: string[];
    source: string;
  }>();

  const emit = defineEmits<{
    onDateSelect: [mode: searchFormCalendar.config.CalendarMode];
  }>();

  const { t } = useI18n();

  const datesLabel = computed(() => {
    const [from, to] = props.dates;
    if (!from) {
      return t('main.dates.placeholder.combined');
    }

    const fromVerbal = dateUtils.getVerbalDate(from);
    if (!to) {
      return fromVerbal;
    }

    const sameMonth = dayjs(from).isSame(dayjs(to), 'month');
    if (sameMonth) {
      const fromDay = dayjs(from).format('D');
      return `${fromDay}\u00A0\u2013 ${dateUtils.getVerbalDate(to)}`;
    }

    return `${fromVerbal}\u00A0\u2013 ${dateUtils.getVerbalDate(to)}`;
  });
</script>
